import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/components/ui/skeleton";
export function FooterSkeleton() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-7 w-24 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" />;
    t1 = <Skeleton className="h-7 w-14 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" />;
    t2 = <Skeleton className="h-7 w-14 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2">{t0}{t1}{t2}<div className="flex items-center gap-2 ml-auto"><Skeleton className="h-7 w-14 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /><Skeleton className="h-7 w-14 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /><Skeleton className="h-7 w-14 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /><Skeleton className="h-7 w-14 rounded-full bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /><Skeleton className="h-8 w-24 rounded-md ml-3 bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="shrink-0 flex flex-col gap-1.5 px-6 pt-1.5 pb-3" data-sentry-component="FooterSkeleton" data-sentry-source-file="FooterSkeleton.tsx">{t3}<div className="flex items-center justify-between gap-3"><Skeleton className="h-3 w-48 bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /><Skeleton className="h-3 w-24 bg-muted-strong" data-sentry-element="Skeleton" data-sentry-source-file="FooterSkeleton.tsx" /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}